
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/items/all",
      function () {
        return require("private-next-pages/items/all.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/items/all"])
      });
    }
  